import { useCallback, useState } from 'react'
import Footer from '../../components/Footer'
import Header from '../../components/Header'
import LandingPageWrapper from '../../components/HomePage/LandingPageWrapper'
import PerPiecePricing from '../../components/PlatformPricing/PerPiecePricing'
import PlanComparison from '../../components/PlatformPricing/PlanComparison'
import PricingAddons from '../../components/PlatformPricing/PricingAddons'
import PricingClosingCta from '../../components/PlatformPricing/PricingClosingCta'
import PricingFaq from '../../components/PlatformPricing/PricingFaq'
import PricingHero from '../../components/PlatformPricing/PricingHero'
import PricingPlans from '../../components/PlatformPricing/PricingPlans'
import PricingTrustBar from '../../components/PlatformPricing/PricingTrustBar'
import TalkToSalesModal from '../../components/PlatformPricing/TalkToSalesModal'
import content from '../../components/PlatformPricing/content'

export default function PlatformPricing({ data = content }) {
    const [billing, setBilling] = useState('monthly')
    const [isSalesModalOpen, setIsSalesModalOpen] = useState(false)
    const openSalesModal = useCallback(() => setIsSalesModalOpen(true), [])
    const closeSalesModal = useCallback(() => setIsSalesModalOpen(false), [])
    return (
        <>
            <LandingPageWrapper sectionSpacing={false} paddingFromTop={false}>
                <Header
                    metaTitle="Pricing | Open Letter Marketing"
                    meta='<meta name="description" content="Compare OLC platform plans, per-piece mail rates, and add-ons. Choose direct mail pricing that scales with your volume." />'
                />
                <main className="font-sans text-olm-black">
                    <PricingHero
                        data={data.hero}
                        billing={billing}
                        onBillingChange={setBilling}
                    />
                    <PricingPlans
                        plans={data.plans}
                        billing={billing}
                        onTalkToSales={openSalesModal}
                    />
                    <PlanComparison
                        data={data.comparison}
                        plans={data.plans}
                        billing={billing}
                    />
                    <PerPiecePricing
                        data={data.perPiece}
                        onTalkToSales={openSalesModal}
                    />
                    <PricingAddons data={data.addons} />
                    <PricingFaq data={data.faq} />
                    <PricingClosingCta data={data.cta} />
                    <PricingTrustBar items={data.trust} />
                </main>
            </LandingPageWrapper>
            <Footer />
            <TalkToSalesModal
                isOpen={isSalesModalOpen}
                onClose={closeSalesModal}
            />
        </>
    )
}
